import { render, staticRenderFns } from "./DriverDisposed.vue?vue&type=template&id=afe2bc4a&scoped=true&"
import script from "./DriverDisposed.vue?vue&type=script&lang=js&"
export * from "./DriverDisposed.vue?vue&type=script&lang=js&"
import style0 from "./DriverDisposed.vue?vue&type=style&index=0&id=afe2bc4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afe2bc4a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VTextField})
